import nextOrPrevUntil from "./_internal/_nextOrPrevUntil.js";

export default nextOrPrevUntil("previousSibling", "unshift");
